import {makeEnumType} from './Enums';
import type { QueryParameters } from './QueryParameters';
import type { ServerFile } from './ServerFile';
export const roles = makeEnumType({
  SuperAdmin:"US",
  US: "US",
  
  Administrators:"UA",
  UA: "UA",
  
  Operators: "UO",
  UO: "UO",

  Beneficiaires:"UU",
  UU: "UU",

  Manager: "UM",
  UM: "UM",
  
  PasValider: "UN",
  UN: "UN", 

  Visitors:"UV",
  UV: "UV",

  Supprime: "UD",
  UD:"UD"
},'role');

export type rolesList= "UU" | "UA" | "UO" | "UV"| "US" | "UM" | "UN" | "UD";

export type Role = (typeof roles)[keyof typeof roles];

export interface Profil {
    [key: string]: string | number | undefined | number[] |ServerFile[];
    id: number,
    nom: string,
    prenom: string,
    civilite:string,
    date_de_naissance: string,
    adresse: string,
    code_postal: string,
    commune: string,
    tel: string,
    mail: string,
    iban: string,
    titulaire_iban:string,
    numero_national: string,
    photo: string,
    date_modif?:string,
    date_creation?:string,
    reconnaissances?:ServerFile[],
    ribs?:ServerFile[],
    carte_identites?:ServerFile[],
    rgus?:ServerFile[],
}
export type User = Profil & AuthUser;

export type RefUser=Partial<User> & Pick<User,"id"> 

export interface AuthUser {
    id: number,
    identifiant: string,
    cookiehash: string,
    email:string,
    rangacces:  rolesList,
    valide?:boolean,
    validation?:boolean, /* c'est quoi la difference? */
    managers?: number[],
    apikey?: string
}

export const roleNames:Record<rolesList,string> = {
  "US": "SuperAdmin",
  "UA": "Admin",
  "UM": "Manager",
  "UO": "Operator",
  "UU": "Beneficiaire",
  "UN": "Attente de Validation",
  "UV": "Visiteur",
  "UD": "Supprimé"
}

export interface UsersLookupParameters{
    [index: string]:string[] | string | number[]| number | undefined;
    statut?:string[] ,
    year?:   number[]| number ,
    rangacces?: string[]
}

export const RoleLevel:Record<rolesList,number> ={
  "UD":-1,
  "UV":0,
  "UN":1,
  "UU":2,
  "UO":3,
  "UM":4,
  "UA":5,
  "US":6,

}

export type UsersParameters = Omit<QueryParameters,'r'> & { r:UsersLookupParameters }
